import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultTestimonialContent: PageTypeContentModule = {
  pageTypeSlug: "testimonial",
  suggestedTitles: ["Customer Reviews", "Success Stories", "What Our Clients Say", "Testimonials"],
  suggestedSlugs: ["reviews", "success-stories", "client-say", "testimonials"],
  description: "Customer reviews and testimonials",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "What Our Customers Say", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "We're proud to have served thousands of satisfied customers. Here's what they have to say about their experience with us.",
        },
      },
      {
        type: "header",
        data: { text: "Customer Reviews", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "★★★★★<br>\"Amazing product! The quality exceeded my expectations and the customer service was outstanding. I highly recommend this to everyone.\"<br>— John D., Happy Customer",
        },
      },
      {
        type: "paragraph",
        data: {
          text: "★★★★★<br>\"Fast shipping and exactly as described. Couldn't be happier with my purchase. Will definitely order again!\"<br>— Sarah M., Satisfied Buyer",
        },
      },
      {
        type: "paragraph",
        data: {
          text: "★★★★★<br>\"Great value for money. The team was very responsive and helped me find exactly what I needed.\"<br>— Michael R., Returning Customer",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
